import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import "./how-it-works.scss";

import { Text, Button, Icon } from "@ui-kit";

const HowItWorks = ({ viewModalSignup }) => {
  const [step, setStep] = useState(1);

  return (
    <div className="how-works">
      <div className="main__container d-flex jc-center">
        <div className="how-works__info">
          <div className="how-works__title">
            <Text as="h2">
              <FormattedMessage
                id="how-works.title.title"
                defaultMessage="How does this work"
              />
            </Text>

            <div className="info__horizontal-tabs">
              <Button
                theme="link-gray"
                size="md"
                className={`tab-link${step === 1 ? " select" : ""}`}
                onClick={() => setStep(1)}
              >
                <FormattedMessage
                  id="how-works.tabs.button1"
                  defaultMessage="Step 1"
                />
              </Button>
              <Button
                theme="link-gray"
                size="md"
                className={`tab-link${step === 2 ? " select" : ""}`}
                onClick={() => setStep(2)}
              >
                <FormattedMessage
                  id="how-works.tabs.button2"
                  defaultMessage="Step 2"
                />
              </Button>
              <Button
                theme="link-gray"
                size="md"
                className={`tab-link${step === 3 ? " select" : ""}`}
                onClick={() => setStep(3)}
              >
                <FormattedMessage
                  id="how-works.tabs.button3"
                  defaultMessage="Step 3"
                />
              </Button>
            </div>
          </div>

          <div className="info__slider">
            <div
              className={`slider__item${step === 1 ? " select" : ""}`}
              id="item-1"
            >
              <div className="slider__item-info">
                <Text as="h4">
                  <FormattedMessage
                    id="how-works.slider.slide1.title"
                    defaultMessage="Enter your search query"
                  />
                </Text>
                <Text as="h5">
                  <FormattedMessage
                    id="how-works.slider.slide1.content"
                    defaultMessage='Enter the query you are interested in in the search bar, for example, "business teamwork" or "summer travel".'
                  />
                </Text>
              </div>
              <div className="slider__item-banner">
                <Icon src="/images/banner-how-work-1.png" />
              </div>
            </div>

            <div
              className={`slider__item${step === 2 ? " select" : ""}`}
              id="item-2"
            >
              <div className="slider__item-info">
                <Text as="h4">
                  <FormattedMessage
                    id="how-works.slider.slide2.title"
                    defaultMessage="KeyHunter analyzes the results"
                  />
                </Text>
                <Text as="h5">
                  <FormattedMessage
                    id="how-works.slider.slide2.content"
                    defaultMessage="The plugin collects an array of keywords used in top works"
                  />
                </Text>
              </div>
              <div className="slider__item-banner">
                <Icon src="/images/banner-how-work-2.png" />
              </div>
            </div>

            <div
              className={`slider__item${step === 3 ? " select" : ""}`}
              id="item-3"
            >
              <div className="slider__item-info">
                <Text as="h4">
                  <FormattedMessage
                    id="how-works.slider.slide3.title"
                    defaultMessage="Sort by sales popularity"
                  />
                </Text>
                <Text as="h5">
                  <FormattedMessage
                    id="how-works.slider.slide3.content"
                    defaultMessage="KeyHunter automatically ranks keywords by sales volume, highlighting the most effective ones"
                  />
                </Text>
              </div>
              <div className="slider__item-banner">
                <Icon src="/images/banner-how-work-3.png" />
              </div>
            </div>
          </div>

          <div className="info__actions">
            <Button onClick={() => viewModalSignup('plugin')}>
              <FormattedMessage
                id="how-works.slider.button"
                defaultMessage="Try it now"
              />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
